module.exports = __webpack_public_path__ + "static/heidi3-c10c7f2af3422f032cb0f95699ce73b0.jpg";